import router from './router'
import store from './store'
import {
  MessageBox
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken
} from '@/utils/auth' // getToken from cookie

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

// permissiom judge function
function hasPermission(menus, code) {
  if (!code) return true
  return menus.some(menu => code.indexOf(menu) >= 0)
}

const whiteList = ['/login', '/authredirect', '/privacyPolicyHw', '/staticPage/Agreement', '/staticPage/PrivacyPolicy', '/staticPage/JiaoXin/PrivacyPolicy', '/staticPage/LinFen/PrivacyPolicy', '/staticPage/LinFen/Agreement', '/purchase/platformGoods', '/purchase/deliveryOrder', '/contactUs', '/aboutUs'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.menus.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          const menus = res.data.result.menus // note: roles must be a array! such as: ['editor','develop']
          const sysUser = res.data.result.sysUser
          store.dispatch('GenerateRoutes', {
            menus,
            sysUser
          }).then(() => { // 根据menus权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访 问路由表(这里是跟菜单一样的路由数组)
            next({
              ...to,
              replace: true
            })
          })
        }).catch((err) => {
          MessageBox.alert('获取用户信息失败，请重新登录。' + err, '登录失败', {
            confirmButtonText: '重新登录',
            center: true,
            callback: action => {
              store.dispatch('LogOut').then(() => {
                // 为了重新实例化vue-router对象 避免bug
                location.reload()
              }).catch(() => {
                // 后台服务无法连接的情况，也重新实例化，刷新之后进入登录页面
                location.reload()
              })
            }
          })
        })
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // 这里根据roles 变成 menus之后需要修改一下，暂标记
        if (whiteList.indexOf(to.path) !== -1) {
          next()
        } else {
          if (hasPermission(store.getters.menus, to.meta.code)) {
            next()
          } else {
            next({
              path: '/401',
              replace: true,
              query: {
                noGoBack: true
              }
            })
          }
        }
        // 可删 ↑
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('/staticPage/MessageDetail/') !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach((to, from) => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js